import { configureStore } from "@reduxjs/toolkit"
import { coreSlice } from "./slices/core.slice"
import { legacyBridgeMiddleware } from "./middleware/legacy-bridge"
import { setStoreRef } from "./store-ref"

/**
 * Core Redux store — created with RTK configureStore.
 *
 * The legacyBridgeMiddleware intercepts plain-object dispatches of
 * effect-only actions (AUTO_LOGIN, APP_LOGOUT, etc.) and converts
 * them to createAsyncThunk dispatches, preserving backward
 * compatibility for all consumer micro frontends.
 */
export const coreStore = configureStore({
  reducer: coreSlice.reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false
    }).prepend(legacyBridgeMiddleware),
  devTools: process.env.NODE_ENV !== "production"
})

setStoreRef(coreStore)

export type RootState = ReturnType<typeof coreStore.getState>
export type AppDispatch = typeof coreStore.dispatch
